/**
 * CtaStepLabel
 * "Step X of Y" line shown at the top of a FormModal / HotelBookingModal while it runs as one step
 * of a multi-step CTA.
 */

import type { CtaStepSequenceContext } from "../../_logic/cta-steps";

interface CtaStepLabelProps {
  sequence: Pick<CtaStepSequenceContext, "stepNumber" | "stepCount">;
}

/**
 * Renders the sequence position.
 * @param props - The running step's position
 * @returns The label paragraph
 */
export function CtaStepLabel({ sequence }: CtaStepLabelProps): JSX.Element {
  return (
    <p className="mb-4 text-sm font-medium text-gray-500">
      Step {sequence.stepNumber} of {sequence.stepCount}
    </p>
  );
}
